import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { IpurseMenu, Icard, IhistoryT, url } from './bodyAll';
import { HTTP } from '@awesome-cordova-plugins/http/ngx';

@Injectable({
  providedIn: 'root'
})
export class WalletService {

  header = {
    'Content-Type':  'application/json',
    'Authorization': localStorage.getItem('TOKEN')
  }

  constructor(
  	private http: HttpClient,
    private httpP: HTTP
  	) { }

  /**
  * Get All monedero
  */ 
  public getAllpurse(id) {
    let seq = this.http.get(`${url}${'purses'}/${'menuPurse'}`, this.header_config()); 
    return seq;
  }
	/**
	* Agregar tarjeta de credito
	* @param body 
	* @param id 
	*/
 	public addCrediCard(body:object,id) {
	  let seq = this.http.post(`${url}${'b_users'}/${'creditCard'}`,body, this.header_config() );
    return seq;
    
 	}
   /**
   * Obtener datos de tarjeta
   * @param id 
   */
   public getAllcard(id) {				//Observable <Icard[]>
     let seq = this.http.get(`${url}${'b_users'}/${'creditCard'}`, this.header_config()); 
     return seq;
   } 
   /**
   * Borrar tarjeta
   * @param id 
   */
   public delCard(id) {				//Observable <Icard[]>
     let seq = this.http.delete(`${url}${'b_users'}/${'creditCard'}/${id}`, this.header_config()); 
     return seq;
   } 
  /**
   * Activar monedero
   * @param body 
   * @param id 
   */
  activePurse(body:Object,id){ //:Observable <any>
    const seq = this.http.post(`${url}${'b_users'}/${'createPurses'}`, body, this.header_config() ); 
    return seq;
  } 
  /**
   * recargar dinero al monedero
   * @param body 
   * @param id_account 
   */ 
  reloadMoney(body:Object,id_account) { 
    /* this.httpP.setDataSerializer('json');
    let seq = this.httpP.post(`${url}${'purses'}/${id_account}/${'operations_root_account'}`, body, this.header ); 
    return seq; */
    let seq = this.http.post(`${url}${'purses'}/${id_account}/${'operations_root_account'}`, body, this.header_config() ); 
    return seq;
  }

  codeSecurity(body:Object,id_account) { 
    let seq = this.http.post(`${url}${'purses'}/${id_account}/${'operations_temp_root_account'}`, body, this.header_config() ); 
    return seq;
  }
  getTransaccion(id_account):Observable <any>{				//IhistoryT 

    let seq = this.http.get(`${url}${'purses'}/${id_account}/${'listPurseOperations'}`, this.header_config()); 
    return seq;
  }
  /**
   * Enviar dinero
   */
  sendMoney(id_account,body) {
    
    let seq = this.http.post(`${url}${'purses'}/${id_account}/${'operations_root_account'}`, body, this.header_config() ); 
    return seq;
  }
  /**
   * pago facil scan qr dinero
   */
  payMoney(id_account,body) { 
    /* this.httpP.setDataSerializer('json');
    let seq = this.httpP.post(`${url}${'purses'}/${id_account}/${'operations_destination_account'}`, body, this.header ); 
    return seq; */
    let seq = this.http.post(`${url}${'purses'}/${id_account}/${'operations_destination_account'}`, body, this.header_config() ); 
    return seq;
  }

  /**  
  * Transferencias recibidas 
  */
  getTranscreveice(id_account): Observable <any>{ 

    let seq = this.http.get(`${url}${'purses'}/${id_account}/${'operations_destination_account'}`, this.header_config()); 
    return seq;

  } 
  /**
  *  guardar cuentas favoritas
  */
  postFavorite(body:Object,id_account){ 
    
    const seq = this.http.post(`${url}${'purses'}/${id_account}/${'favoriteAccounts'}`, body, this.header_config() ); 
    return seq;
  }

  getFavorites(id_account){ 

    let seq = this.http.get(`${url}${'purses'}/${id_account}/${'favoriteAccounts'}`, this.header_config()); 
    return seq;
  }

  /**
  * Get All membership
  */ 
  public getAllmemberships() {
    let seq = this.http.get(`${url}${'memberships'}`, this.header_config()); 
    return seq;
  }
  /**
  * Set membership
  */ 
  public payMemberships(body) {
    let seq = this.http.post(`${url}${'memberships'}`, body,this.header_config()); 
    return seq;
  }
  

  /**
  * Get All monedero
  */ 
   public getAllservices(id) {
    let seq = this.http.get(`${url}${'billservice'}`, this.header_config()); 
    return seq;
  }
  /**
  *  enviar pago de servicio
  *
  */
  public setPayService(id, body) { 
    /* this.httpP.setDataSerializer('json');
    let seq = this.httpP.post(`${url}${'billservice'}`, body, this.header ); 
    return seq; */
    let seq = this.http.post(`${url}${'billservice'}`, body, this.header_config() ); 
    return seq;
  }

  /**
  *  ENVIAR CODIGO DE VALIDACION DESDE EL SERVIDOR AL CELULAR
  */ 
  public gedCodePhone(id, phone) {
    let seq = this.http.get(`${url}${'cardv'}/${phone}`, this.header_config()); 
    return seq;
  }

  /**
  *  ENVIAR SOLICITUD DE TARJETA DE CREDITO VIRTUAL
  */
  public setRequestVirtualCard(id, body){
    
    let seq = this.http.post(`${url}${'cardv'}`, body, this.header_config() ); 
    return seq;
  }

  /**
  *  ENVIAR SOLICITUD DE TARJETA DE CREDITO VIRTUAL
  */
  public getRequestVirtualCard(){
    
    let seq = this.http.get(`${url}${'cardv'}`, this.header_config() ); 
    return seq;
  }

  /**
  *  OBTENER OPCIONES DE AHORRO
  * /${userId}/${number_account}
  * number_account, userId
  * 
  */
  public getTypePocket() {
    let seq = this.http.get(`${url}${'pocketType'}`, this.header_config()); 
    return seq;
  }
  /**
  *  CREAR BOLSILLO PARA LA CUENTA
  */
  public setPocket(number_account, userId, body){
    
    let seq = this.http.post(`${url}${'pocket'}/${number_account}`, body, this.header_config() ); 
    return seq;
  }

  public getPocket(number_account, userId){
    let seq = this.http.get(`${url}${'pocket'}/${number_account}`, this.header_config()); 
    return seq;
  }
  /**
  *  obtener datos del usuario por el monedero
  */
  public getDataByPurse(number_account){
    let seq = this.http.get(`${url}${'purses'}/${number_account}/${'bUser'}`, this.header_config()); 
    return seq;
  }
  /**
   * 
   * @returns CoinId []
   */
  getCurrencies() { 
    let seq = this.http.get(`${url}${'currencies'}`, this.header_config() ); 
    return seq;
  }
  /**
   * 
   * @returns CoinId []
   */
  getCurrenciesP2p() { 
    let seq = this.http.get(`${url}${'currenciesp2p'}`, this.header_config() ); 
    return seq;
  }

  /**
   * 
   * @returns Propousal []
   */
   getOrdersP2P(currency, operation) { 
    let seq = this.http.get(`${url}${'ordersp2p'}/${currency}/${operation}`, this.header_config() ); 
    return seq;
  }
  /**
   * 
   * @returns Propousal []
   */
   searchOrdersP2P(currency, operation, body) { 
    let seq = this.http.post(`${url}${'ordersp2p'}/${currency}/${operation}`, body, this.header_config() ); 
    return seq;
  }
  /**
   * 
   * @returns Propousal
   */
   getOrderP2P(orderId) { 
    let seq = this.http.get(`${url}${'ordersp2p'}/${orderId}`, this.header_config() ); 
    return seq;
  }
  /**
   * 
   * @returns Propousal Chat operation
      order: Propousal,
      chat: idChat
   */
  doOperation(body, orderId) { 
    let seq = this.http.post(`${url}${'ordersp2p'}/${orderId}`, body, this.header_config() ); 
    return seq;
  }

  putNotyOperateOrderP2P(chatId, body={}){
    let seq = this.http.put(`${url}ordersp2p/${chatId}/noty`, body, this.header_config() ); 
    return seq;
  }

  putReleaseOperateOrderP2P(orderId, body={}){
    let seq = this.http.put(`${url}${'ordersp2p'}/${orderId}/release`, body, this.header_config() ); 
    return seq;
  }
  /**
   * 
   * @returns Propousal 
   */
   setOrdersP2P(body) { 
    let seq = this.http.post(`${url}${'ordersp2p'}`, body, this.header_config() ); 
    return seq;
  }
  /**
   * 
   * @returns Propousal 
   */
   deleteOrdersP2P(orderId) { 
    let seq = this.http.delete(`${url}${'ordersp2p'}/${orderId}`, this.header_config() ); 
    return seq;
  }
  /**
   * 
   */
  getMethodsp2p(){
    let seq = this.http.get(`${url}${'methodsp2p'}`, this.header_config() ); 
    return seq;
  }

  /**
   * 
   * @returns Propousal []
   */
   getOrders(currency, operation) {
    let urlFull = `${url}${'orders'}`

    if(currency)
      urlFull+=`/${currency}`
    if(operation)
      urlFull+=`/${operation}`

    let seq = this.http.get(urlFull, this.header_config() ); 
    return seq;
  }
  /**
   * 
   * @returns Propousal
   */
  getOrder(orderId) { 
    let seq = this.http.get(`${url}${'order'}/${orderId}`, this.header_config() ); 
    return seq;
  }

  
  getOrderOperation(chatId) { 
    let seq = this.http.get(`${url}${'order/operation'}/${chatId}`, this.header_config() ); 
    return seq;
  }

  getMethods(){
    let seq = this.http.get(`${url}${'methods'}`, this.header_config() ); 
    return seq;
  }

  putMethodp2p(body){
    let seq = this.http.put(`${url}${'methods'}`, body,this.header_config() ); 
    return seq;
  }

  setMethodp2p(body){
    let seq = this.http.post(`${url}${'methods'}`, body,this.header_config() ); 
    return seq;
  }

  deleteMethod(id){
    let seq = this.http.delete(`${url}methods/${id}`, this.header_config() ); 
    return seq;
  }

  /**
   * 
   * @returns {msg: string, status: boolean}
   */
   validLimitsConditionsForOrder(orderId) { 
    let seq = this.http.get(`${url}${'ordersp2p'}/valid/${orderId}`, this.header_config() ); 
    return seq;
  }
  /**
   * 
   * @returns Propousal []
   */
  searchOrders(currency, operation, body) { 
    let seq = this.http.post(`${url}${'orders'}/${currency}/${operation}`, body, this.header_config() ); 
    return seq;
  }

  /**
   * METAAMASK
   * @param  
   * @param result 
  */
  
  public setBalanceMetamask(body) {
    let seq = this.http.post(`${url}metamaskbalance`, body, this.header_config() ); 
    return seq;
  }
  /**
  *  guardar cuentas favoritas
  */
  postFavoriteMetamask(body:Object,id_account){ 
    
    const seq = this.http.post(`${url}${'purses'}/${id_account}/${'favoriteAccountsMeta'}`, body, this.header_config() ); 
    return seq;
  }

  /**
   * Enviar dinero
   */
  sendOperationMetamaks(id_account,body) {
    let seq = this.http.post(`${url}${'purses'}/${id_account}/${'operations_destination_account_metamask'}`, body, this.header_config() ); 
    return seq;
  }
  
	private handleError<T> (operation = 'operation', result?: T) {
    /* return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      console.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    }; */
  }
	
	public header_config (){
    let extra = localStorage.getItem('key') ? " "+ localStorage.getItem('key') : ""
    let token = localStorage.getItem('TOKEN')
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': token ? token : '' + extra
      })
    };
    return httpOptions;

    // let headers      = new Headers({ 'Content-Type': 'application/json','Authorization':localStorage.getItem('TOKEN')}); 
    // let options       = { headers: headers };   
    // return options;

  };

}
